import {provideHttpClient, withInterceptors} from '@angular/common/http'
import {ApplicationConfig, inject, provideAppInitializer} from '@angular/core'
import {MAT_CARD_CONFIG} from '@angular/material/card'
import {MAT_FORM_FIELD_DEFAULT_OPTIONS} from '@angular/material/form-field'
import {MatPaginatorIntl} from '@angular/material/paginator'
import {provideRouter, withHashLocation, withInMemoryScrolling} from '@angular/router'
import {
  authInterceptor,
  ConfigService,
  IConfig,
  responseInterceptor,
  SPB_LOGIN_SETTINGS,
  SPS_CONFIG
} from '@sparbanken-syd/sparbanken-syd-bankid'
import {SpbPaginatorSv} from '@sparbanken-syd/sparbanken-syd-theme'
import {ADMIN_ROLE} from '@sparbanken-syd/spb-savings-account-backend'
import {environment} from '../environments/environment'
import {routes} from './app.routes'
import {ADMIN_HOME_PATH, WINDOW} from './application/app'

const configServiceConfig: IConfig = {
  authServiceUrl: environment.authServiceUrl,
  domain: environment.domain,
  adminRoles: [ADMIN_ROLE]
}

export const appConfig: ApplicationConfig = {
  providers: [
    {provide: WINDOW, useValue: window},
    {provide: SPS_CONFIG, useValue: configServiceConfig},
    {
      provide: SPB_LOGIN_SETTINGS, useValue: {
        text: 'För att komma igång behöver du först logga in med ditt BankID',
        buttonText: 'Logga in med BankID',
        title: '',
        route: ['/', ADMIN_HOME_PATH]
      }
    },
    provideAppInitializer(() => inject(ConfigService).bootstrap()),
    {provide: MatPaginatorIntl, useClass: SpbPaginatorSv},
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: {
        floatLabel: 'always',
        hideRequiredMarker: true,
        appearance: 'outline',
        subscriptSizing: 'dynamic'
      }
    },
    {provide: MAT_CARD_CONFIG, useValue: {appearance: 'outlined'}},
    provideRouter(routes, withHashLocation(), withInMemoryScrolling({anchorScrolling: 'enabled'})),
    provideHttpClient(
      withInterceptors([
        authInterceptor,
        responseInterceptor
      ])
    )
  ]
}